import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import * as LucideIcons from 'lucide-react';
import axios from 'axios';

const DynamicIcon = ({ name }) => {
  const key = LucideIcons[name] ? name : (name || '')
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join('');
  const IconComponent = LucideIcons[key] || LucideIcons.FileText;
  return <IconComponent className="w-5 h-5 text-[#172554]" />;
};

export default function AllServices() {
  const navigate = useNavigate();
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    axios.get(`${API_URL}/api/subservices`)
      .then(res => {
        setSubCategories(res.data);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const handleSubServiceClick = (sub) => {
    // We need to fetch the parent service slug, but AllServices might not have the parent service list handy if it only fetched subservices.
    // Actually AllServices fetches from /api/services maybe? Let's check how it gets data.
    // If it only has category_name, we can just use encodeURIComponent for now, since SubCategory component handles both slug and title.
    const catSlug = encodeURIComponent(sub.category_name);
    const subSlug = sub.slug || encodeURIComponent(sub.title);
    const dest = `/${catSlug}/${subSlug}/form`;

    if (!localStorage.getItem('userToken')) {
      sessionStorage.setItem('intended_dest', dest);
      window.dispatchEvent(new CustomEvent('openAuthModal'));
      return;
    }
    navigate(dest);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans flex flex-col">
      <Header />
      <main className="flex-1 px-4 md:px-24 py-8 w-full max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold text-[#172554] text-gujarati mb-6 border-b-2 border-[#F5B800] pb-2 inline-block">
          તમામ સેવાઓ (All Services)
        </h2>
        
        {loading ? (
          <div className="py-10 text-center text-[#172554]">Loading...</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {(subCategories || []).map((sub, idx) => (
              <div 
                key={idx} 
                className="bg-white border border-[#E2E8F0] p-4 rounded-lg flex flex-col items-center gap-3 cursor-pointer group hover:border-[#FFC928] hover:shadow-md transition-all text-center"
                onClick={() => handleSubServiceClick(sub)}
              >
                <div className="h-14 w-14 flex items-center justify-center text-[#172554] bg-[#F8FAFC] group-hover:bg-[#FFF8DB] rounded-full transition-colors border border-transparent group-hover:border-[#FFC928]">
                  <DynamicIcon name={sub.icon_type} />
                </div>
                <div className="flex flex-col">
                  <span className="font-bold text-[#172554] text-gujarati text-sm md:text-base leading-tight">
                    {sub.title}
                  </span>
                  <span className="text-[10px] text-[#64748B] mt-1">{sub.category_name}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
